module.exports = __webpack_public_path__ + "static/media/error-img.892dd88a.png";